import { getUrlWithStoredParams } from "@/components/Routing/redirectFromLoader";
import { getSessionStorageValue } from "@/hooks/useLocalStorage";
import { ticketStorageKeys } from "@/queries/tickets/filters";

import type { PortfolioRouteParams } from "../../routes";

export const PORTFOLIO_TICKET_FILTER_STORAGE_KEY = ticketStorageKeys.portfolio_filters();

const TICKET_PAGE_FILTER_PARAM_KEYS = [
  "tab",
  "search",
  "sort",
  "statusKeys",
  "categoryNames",
  "assigneeAccountIds",
  "assigneeMode",
  "ratings",
  "visibility",
  "isUnreadOnly",
] as const satisfies readonly (keyof PortfolioRouteParams["tickets"])[];

/** The page-owned filters the list remembers for the tab. The shared project scope stays URL-only. */
export function getTicketPageFilterParams(
  queryParams: Partial<PortfolioRouteParams["tickets"]>,
): Partial<PortfolioRouteParams["tickets"]> {
  return Object.fromEntries(TICKET_PAGE_FILTER_PARAM_KEYS.map((key) => [key, queryParams[key]]));
}

/**
 * The portfolio ticket list URL with the filters stored earlier in this tab, when the URL has none of its own.
 * The route loader redirects there before the page renders, so the page only queries the filtered list.
 */
export function getStoredPortfolioTicketFiltersUrl(url: URL): string | undefined {
  const stored = getSessionStorageValue<Partial<PortfolioRouteParams["tickets"]>>(
    PORTFOLIO_TICKET_FILTER_STORAGE_KEY,
    {},
  );

  return getUrlWithStoredParams(url, TICKET_PAGE_FILTER_PARAM_KEYS, getTicketPageFilterParams(stored));
}
